import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { TrafficFunnel } from '@mkp/shared/models';
import { AppConfig } from '@mkp/shared/util-app-config';

@Injectable({
  providedIn: 'root',
})
export class ActiveTrafficFunnelGuard {
  private router = inject(Router);

  readonly trafficFunnels = Object.values(TrafficFunnel);

  canActivate(route: ActivatedRouteSnapshot) {
    const { funnel = null } = route.params;
    return (
      this.trafficFunnels.includes(funnel) || this.router.parseUrl(AppConfig.routes.onboarding)
    );
  }
}
